import { get, post } from "@/infra/rest";

// Response from GET endpoint
export interface IntakeFormResponse {
  success: boolean;
  intake_form_url: string;
}

// Question payload for save (based on BE API contract)
export interface SaveIntakeFormQuestionPayload {
  question_number: string;
  question: string;
  field_name: string;
  question_type: "free_text" | "single_choice" | "multiple_choice" | "file_upload";
  required: boolean;
  is_dropdown: boolean;
  hidden_from_user: boolean;
  response_choices?: string[];
  max_number_of_files?: number; // For file_upload type
}

// Save request payload
export interface SaveIntakeFormPayload {
  questions: SaveIntakeFormQuestionPayload[];
}

// Save response
export interface SaveIntakeFormResponse {
  success: boolean;
  intake_form_url: string;
}

/**
 * Get organization's intake form
 */
export const getIntakeForm = async (): Promise<IntakeFormResponse> => {
  return get<IntakeFormResponse>({
    url: '/v0/tpra/vendor-intake-form',
    isAuthRequired: true,
  });
};

/**
 * Save intake form after editing
 */
export const saveIntakeForm = async (
  payload: SaveIntakeFormPayload
): Promise<SaveIntakeFormResponse> => {
  return post<SaveIntakeFormPayload, SaveIntakeFormResponse>({
    url: '/v0/tpra/vendor-intake-form/save',
    data: payload,
    isAuthRequired: true,
  });
};
